import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import SelectBox from "components/Common/SelectBox"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import RtwProductAction from "store/rtw-product-resource/actions"
import CompanyAction from "store/company-resource/actions"
import SeasonAction from "store/season-resource/actions"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"

export default function RWTProduct() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
  })
  const [pagination, setPagination] = React.useState({
    page: 0,
    size: 10,
  })

  const [filter, setFilter] = useState({
    number: "",
    supplierName: "",
    year: "",
    seasonName: "",
  })

  const columns = React.useMemo(
    () => [
      {
        Header: "商品番号",
        accessor: "number",
        defaultCanSort: false,
      },
      {
        Header: "お取引先",
        accessor: "supplierName",
        defaultCanSort: false,
      },
      {
        Header: "年度",
        accessor: "year",
        defaultCanSort: false,
      },
      {
        Header: "シーズン",
        accessor: "seasonName",
        defaultCanSort: false,
      },
      {
        Header: "商品名",
        accessor: "name",
        defaultCanSort: false,
      },
      {
        Header: "ステータス",
        accessor: "status",
        defaultCanSort: false,
        Cell: ({ cell }) => {
          return <span>{cell.row.original.status ? "販売中" : "廃盤"}</span>
        },
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(`/master/rtw-product/${cell.row.original.id}`)
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  React.useEffect(() => {
    dispatch(RtwProductAction.getListPage({ ...params, ...pagination }))
  }, [params, pagination])

  React.useEffect(() => {
    dispatch(CompanyAction.getList())
    dispatch(SeasonAction.getList())
  }, [])

  const onChangeFilter = e => {
    const { name, value } = e.target
    setFilter({
      ...filter,
      [name]: value,
    })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    setParams({
      ...filter,
      page: 0,
      size: 10,
    })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="RTW商品マスター" breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={2}>
                <TextInputWithLabel
                  label={"商品番号"}
                  placeholder={""}
                  value={filter.number}
                  type="text"
                  name="number"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={2}>
                <SelectBox
                  label="お取引先"
                  name="supplierName"
                  value={{
                    value: filter.supplierName,
                    label: filter.supplierName,
                  }}
                  options={store.company.list.data.map(i => ({
                    value: i.name,
                    label: i.name,
                  }))}
                  onChange={e => {
                    if (e) {
                      setFilter({ ...filter, supplierName: e.label })
                    } else {
                      setFilter({ ...filter, supplierName: "" })
                    }
                  }}
                />
              </Col>
              <Col md={2}>
                <TextInputWithLabel
                  label={"年度"}
                  placeholder={""}
                  value={filter.year}
                  type="text"
                  name="year"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={2}>
                <SelectBox
                  label="シーズン"
                  name="seasonName"
                  value={{
                    value: filter.seasonName,
                    label: filter.seasonName,
                  }}
                  options={store.seasonPage.list.data.map(i => ({
                    value: i.name,
                    label: i.name,
                  }))}
                  onChange={e => {
                    if (e) {
                      setFilter({ ...filter, seasonName: e.label })
                    } else {
                      setFilter({ ...filter, seasonName: "" })
                    }
                  }}
                />
              </Col>
              <Col md={1} className="d-flex align-content-end flex-wrap">
                <SButton className="mx-2 button" onClick={() => onSearch()}>
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row className="mb-3">
              <Col sm="6" />
              <Col
                sm="6"
                className="d-flex align-items-end justify-content-end"
              >
                <SButton
                  className="mx-2 button"
                  onClick={() => history.push("/master/rtw-product/add")}
                >
                  新規RTW商品
                </SButton>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                {store.rtwProduct.pageData.loading ? (
                  <Skeleton count={5} />
                ) : store.rtwProduct.pageData.data?.content?.length === 0 ? (
                  <h3 className="text-center">No Data to Display</h3>
                ) : (
                  <TableContainer
                    data={store.rtwProduct.pageData.data?.content || []}
                    columns={columns}
                    pagination
                    page={pagination.page}
                    size={pagination.size}
                    count={store.rtwProduct.pageData.data?.totalPages || 1}
                    setParams={setPagination}
                    params={pagination}
                  />
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
